import { Controller } from "@hotwired/stimulus"
import * as bootstrap from "bootstrap"

// Opens Bootstrap modal when turbo frame content loads into the modal frame
export default class extends Controller {
  connect() {
    this.modal = new bootstrap.Modal(this.element)

    // Listen for turbo:frame-load on the modal's turbo frame
    this.frameElement = this.element.querySelector("turbo-frame#modal")
    if (this.frameElement) {
      this.boundOpen = this.openModal.bind(this)
      this.frameElement.addEventListener("turbo:frame-load", this.boundOpen)
    }

    // Reset frame content when modal is hidden
    this.boundReset = this.resetFrame.bind(this)
    this.element.addEventListener("hidden.bs.modal", this.boundReset)
  }

  disconnect() {
    if (this.frameElement && this.boundOpen) {
      this.frameElement.removeEventListener("turbo:frame-load", this.boundOpen)
    }
    if (this.boundReset) {
      this.element.removeEventListener("hidden.bs.modal", this.boundReset)
    }
    if (this.modal) {
      this.modal.dispose()
    }
  }

  openModal() {
    this.modal.show()
  }

  resetFrame() {
    if (this.frameElement) {
      this.frameElement.innerHTML = `
        <div class="modal-body text-center py-5">
          <div class="spinner-border text-success" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
      `
    }
  }

  // Called from close buttons inside the modal
  close() {
    this.modal.hide()
  }
}
